'use client'

import { Container } from '@src/components/Container/Container'
import { type RailProps } from '@src/components/Rail/Rail.props'
import { useBreakpoints } from '@src/utils/breakpoints.util'
import { cn } from '@src/utils/tailwind'

import { RailItem } from './RailItem'

type RailGridProps = Pick<
  RailProps,
  'items' | 'columnsDesktop' | 'columnsMobile' | 'builderBlock' | 'imageStyle' | 'slug'
> & {
  isPreviewing?: boolean
}

export const RailGrid = (props: RailGridProps) => {
  const { items, columnsDesktop, columnsMobile, isPreviewing, builderBlock, imageStyle, slug } =
    props
  const breakpoints = useBreakpoints()
  const isMobile = breakpoints.isMobile || breakpoints.isTablet

  const columns = isMobile ? columnsMobile : columnsDesktop

  const renderItems = () => {
    return items.map(({ blocks }, index) => (
      <RailItem
        key={index}
        index={index}
        isPreviewing={isPreviewing}
        builderBlock={builderBlock}
        imageStyle={imageStyle}
        blocks={blocks}
        columnsDesktop={columnsDesktop ?? 1}
        slug={slug}
      />
    ))
  }

  return (
    <Container>
      <div
        className={cn('grid gap-x-3 gap-y-6 lg:gap-8')}
        style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
      >
        {renderItems()}
      </div>
    </Container>
  )
}
